var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.307,
    height: 113.301,
    viewBox: "0 0 113.307 113.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment-dollar",
    d: "M60.6.131A56.668,56.668,0,0,0,.136,60.68c2.082,30,28.577,52.622,61.63,52.622H89.7A23.633,23.633,0,0,0,113.307,89.7V58.253C113.307,27.67,90.159,2.138,60.6.131Zm.774,80.123v4.721a4.721,4.721,0,0,1-9.442,0V80.254H50.667A14.213,14.213,0,0,1,38.4,73.177a4.718,4.718,0,1,1,8.168-4.726,4.752,4.752,0,0,0,4.093,2.361H61.37a4.726,4.726,0,0,0,4.721-4.721,3.627,3.627,0,0,0-3.04-3.588L48.693,60.109a13.035,13.035,0,0,1-10.93-12.9A14.181,14.181,0,0,1,51.927,33.042V28.321a4.721,4.721,0,1,1,9.442,0v4.721h1.265A14.217,14.217,0,0,1,74.9,40.124a4.718,4.718,0,1,1-8.168,4.726A4.742,4.742,0,0,0,62.64,42.49H51.932a4.726,4.726,0,0,0-4.721,4.721,3.627,3.627,0,0,0,3.04,3.588l14.357,2.394a13.035,13.035,0,0,1,10.93,12.9A14.181,14.181,0,0,1,61.375,80.259Z",
    transform: "translate(0 -0.002)",
    fill: "#153c42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDollar);
export default __webpack_public_path__ + "static/media/comment-dollar.ee4ddbffc5aec13ea87d89d92f5dd235.svg";
export { ForwardRef as ReactComponent };